import React, { ReactNode } from "react";
import VisuallyHidden from "../../VisuallyHidden/VisuallyHidden";
import styles from "./TextInput.module.scss";

export interface TextInputProps {
  label?: string;
  icon?: ReactNode | string;
  onChange?: (event: React.FormEvent<HTMLInputElement>) => void;
  onKeyPress?: () => void;
  placeholder?: string;
  type?: "text" | "search" | "number" | "number" | "password" | "email";
  value: string;
  role?: string;
  labelVisuallyHidden?: boolean;
}

const TextInput = ({
  label,
  icon = null,
  onChange,
  onKeyPress,
  role,
  placeholder = "Enter here",
  type = "text",
  value = "",
  labelVisuallyHidden,
  ...rest
}: TextInputProps) => (
  <div className={styles.textInputContainer}>
    {label && (
      <label htmlFor={label}>
        {labelVisuallyHidden ? <VisuallyHidden>{label}</VisuallyHidden> : label}
      </label>
    )}
    <div className={styles.inputContainer}>
      <div className={styles.textInputIcon}>{icon}</div>
      <input
        role={role}
        type={type}
        name={label}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyPress={onKeyPress}
        className={styles.textInput}
        {...rest}
      />
    </div>
  </div>
);

export default TextInput;
